import { Client, recaptcha } from '@idonatedev/idonate-sdk';
const iDonateSdk = {
  install(Vue, options) {
    // Events pages have no embed: the SDK authorizes by organization.
    Vue.prototype.$sdkClient = new Client(options.id, undefined, {
      ...options.sdkConfig,
      sdkClientName: 'events-pages',
    });

    recaptcha.injectScript();
    Vue.prototype.$captcha = recaptcha.wrapElement(
      'captcha-challenge',
      options.recaptchaKey,
      {
        size: 'invisible',
      },
    );

  },
};

export default iDonateSdk;
